/**
 * @author      yontaek@zumper.com (Yon Taek Chung)
 * @copyright   Copyright (c) 2019, Zumper
 * @description pushUrlWithFilters Helper
 */

import { FILTERS_START_RE, compareUrls } from '@zcode/nr-utils'
import { rootRelative } from '@zcode/utils'
import Filter from '../../../../shared/bizos/filter'
import DEFAULT_FILTERS from '../../../../shared/constants/default_filters'
import { ON_BROWSER } from '../../../../shared/env'
import { getPathFromFilters } from '../../../../shared/utils/urls/getPathFromFilters'
import { shouldOpenBlank } from '../../../../shared/utils/utils'
import { getPOJOPathAndSearchFiltersFromUrl } from './getPOJOPathAndSearchFiltersFromUrl'
import { getSearchUrlFromPathAndFilters } from './getSearchUrlFromPathAndFilters'

export const getRelativeUrlFromFiltersAndLocationHelper = (filters, oldUrl, bubbleId) => {
  let url = oldUrl
  const m = FILTERS_START_RE.exec(url)
  if (m) {
    url = url.slice(0, m.index)
  }
  url = url.replace(/\/+$/, '')

  // bubble id
  if (bubbleId) {
    url += `/${bubbleId}`
  }
  url += getPathFromFilters(filters)
  // ensure path is relative
  return url[0] === '/' ? url.replace(/^[/]*/, '') : url
}

export const getRelativeUrlFromFiltersAndLocation = ({
  bubbleId,
  currentUrl,
  filters,
  locationUrlQueries,
  omitBox,
}) => {
  const path = getRelativeUrlFromFiltersAndLocationHelper(filters, currentUrl, bubbleId)
  return getSearchUrlFromPathAndFilters({
    filters,
    locationUrlQueries,
    omitBox,
    path,
  })
}

const pushUrlWithFilters =
  ({ event, filters, resetHousingType, to, toNewTab }) =>
  (dispatch) => {
    let linkUrl = rootRelative(to)

    if (ON_BROWSER && filters) {
      const urlFilters = getPOJOPathAndSearchFiltersFromUrl(linkUrl)
      let newFilters = Filter.fromJS({ ...filters, ...urlFilters })

      // Reset Housing Type when needed
      if (resetHousingType) {
        newFilters = {
          ...newFilters,
          propertyCategories: DEFAULT_FILTERS.propertyCategories,
          sort: DEFAULT_FILTERS.sort,
        }
      }

      // get current url and compare with new url generated from filters
      const newUrl = rootRelative(
        getRelativeUrlFromFiltersAndLocation({
          filters: newFilters,
          currentUrl: linkUrl,
        })
      )
      // don't parameterize some verticals https://zumper.atlassian.net/browse/ZUM-48060
      // 3/11/2022  -Hank
      if (!compareUrls(newUrl, linkUrl)) {
        if (
          !linkUrl?.includes('cheap') &&
          !linkUrl?.includes('furnished') &&
          !linkUrl?.includes('short-term')
        ) {
          linkUrl = newUrl
        }
      }
    }
    if (shouldOpenBlank(event) || toNewTab) {
      window.open(linkUrl, '_blank')
    } else {
      window.location.href = linkUrl
    }
  }

export default pushUrlWithFilters
